import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import cookies from 'vue-cookies'
import axios from 'axios'
import '@/assets/global.css';

axios.interceptors.request.use(
  function(config) {
    store.dispatch('updateState', ['loading', true])
    config.withCredentials = true
    return config
  },
  function(error) {
    // Do something with request error

    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  function(config) {
    store.dispatch('updateState', ['loading', false])
    return config
  },
  function(error) {
    store.dispatch('updateState', ['loading', false])
    console.log(error)
    if (error.response && error.response.status === 403) {
      store.dispatch('updateState', ['user', null])
    }
    // We should actually do something better here...
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false
//

/*
  There's a lot going on here, and the event order is important.
  We have to initialize the Vuex store before the Vue app is even created.
  If we don't, the vue router beforeEach navigation guard will run before the API user auth check has come back.

  So... the store's setUserFromServer action is set up to return the chained axios promise,
  and then below below, we are waiting for that promise to be fulfilled to mount the app.

  The app still makes a decision to redirect to the login page based on the results of that axios call,
  we just have to wait to mount it.

  Note also that, at least for now, it's not important for this App to mess with the cookies at all,
  because the {withCredentials => true} in the axios call tells the browser to send the cookies
  straight to the API server in the XHR.
*/


store.dispatch('setUserFromServer').then(newpromise => {
  new Vue({
    router,
    store,
    vuetify,
    created() {
      Object.defineProperty(Vue.prototype, '$cookies', { value: cookies })
      Object.defineProperty(Vue.prototype, '$axios', { value: axios })
      // Object.defineProperty(Vue.prototype, '$authToken', { value: cookies.get('t') })
    },
    render: h => h(App)
  }).$mount('#app')
})

store.dispatch('initLabels')
